import React , {forwardRef, useImperativeHandle, useState} from 'react'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'


//const Modals  = forwardRef((props, ref) => {
const Modals  = forwardRef(({fncallback,fncallback2}, ref) => {
  
  const [lctitle, setlctitle] = useState('');
  const [lcbody, setlcbody] = useState('');
  const [fullscreen, setfullscreen] = useState(false);
  const [iserror, setiserror] = useState(false);
  const [showtwobutton,setshowtwobutton] = useState('');

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useImperativeHandle(ref, () => ({
      fnshow(lctitle,lcbody,fullscreen,iserror,showtwobutton) {
        setlctitle(lctitle);                 
        setlcbody(lcbody);                 
        setfullscreen(fullscreen); 
        setiserror(iserror);      
        setshowtwobutton(showtwobutton);         
        
        handleShow();
      },
      fnclose() {          
        handleClose();
      },
    }));

return (

    <div>
 <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        fullscreen={fullscreen}
      >
        {/* <Modal.Header closeButton> */}
        <Modal.Header>
          <Modal.Title>{lctitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>        
        <strong>{lcbody}</strong>
        </Modal.Body>
        <Modal.Footer>
          {/* <Button variant="primary" onClick={fncallback}>ตกลง</Button> */}

          { iserror === true ? <Button variant="primary" onClick={(e) => fncallback(e,iserror)}>ตกลง</Button> : null}

          { iserror === false && showtwobutton === "2" ? (
              <span>
              <Button variant="primary" onClick={(e) => fncallback(e,iserror)}>ตกลง</Button>
              <Button variant="secondary" onClick={handleClose}>ยกเลิก</Button>
              </span>
          ) : null}
 
 
          { iserror === false && showtwobutton === "1" ? (
              <span>
              <Button variant="primary" onClick={(e) => fncallback(e,iserror)}>ตกลง</Button>              
              </span>
          ) : null}
      
          { iserror === false && showtwobutton === "0" ? (
              <span>
              <Button variant="primary" onClick={(e) => fncallback2(e,iserror)}>ตกลง</Button>              
              </span>
          ) : null}


        
         
        </Modal.Footer>
      </Modal>
    </div>

);

});
export default Modals